<template>
  <div class="card card-with-margin ratings-item">
    <h2 data-skill-name class="skill-name">
      {{ rating.skill.name }}
    </h2>
    <div class="slider">
      <label class="rating-label">
        {{ proficiencyValueToExplanationFormatter(ratingModel.proficiency) }}
      </label>
      <b-slider
        v-model="ratingModel.proficiency"
        class="rating-slider"
        type="is-info"
        :min="1"
        :max="5"
        :step="1"
        :tooltip="false"
        :disabled="!canEdit"
        data-proficiency-slider
        @change="updateRating({ proficiency: $event })"
      >
        <b-slider-tick v-for="val in [1, 2, 3, 4, 5]" :key="val" :value="val">{{
          val
        }}</b-slider-tick>
      </b-slider>
    </div>
    <div class="slider">
      <label class="rating-label">
        {{ interestValueToExplanationFormatter(ratingModel.interest) }}
      </label>
      <b-slider
        v-model="ratingModel.interest"
        class="rating-slider"
        type="is-info"
        :min="1"
        :max="5"
        :step="1"
        :tooltip="false"
        :disabled="!canEdit"
        data-interest-slider
        @change="updateRating({ interest: $event })"
      >
        <b-slider-tick v-for="val in [1, 2, 3, 4, 5]" :key="val" :value="val">{{
          val
        }}</b-slider-tick>
      </b-slider>
    </div>
  </div>
</template>

<script>
import { useStore } from '@/store'

const interestValueToTooltipStringMap = {
  1: 'Zero interest',
  2: 'Will work in it if required',
  3: 'Would like to work in it / Like working in it',
  4: 'Would love to work with it',
  5: 'Working with it is a top priority',
}

export const proficiencyValueToTooltipStringMap = {
  1: 'Zero experience',
  2: 'Dabbled in it for fun / trying to learn it',
  3: 'Worked with it, but by no means an expert',
  4: 'Can contribute meaningfully without guidance',
  5: 'Very experienced, & can teach best practices',
}

export default {
  props: {
    rating: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      ratingModel: { ...this.rating },
      interestValueToExplanationFormatter: (v) => interestValueToTooltipStringMap[v],
      proficiencyValueToExplanationFormatter: (v) => proficiencyValueToTooltipStringMap[v],
    }
  },
  methods: {
    updateRating(params) {
      useStore().updateRating({
        ...params,
        id: this.ratingModel.id,
      })
    },
  },
}
</script>

<style>
.ratings-item {
  padding: 1.25rem;
}

.rating-slider {
  margin: 0rem 0.5rem 3rem;
}
</style>
